import {rewardsActionTypes} from "./rewards.actionTypes";

const initialState = {
  rewardsDetailsLoading: false,
  rewardsDetailsMainLoading: false,
  mmDetailsLoading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case rewardsActionTypes.SET_REWARDS_DETAILS_LOADING: {
      return {...state, rewardsDetailsLoading: true};
    }
    case rewardsActionTypes.SET_REWARDS_DETAILS_SUCCESS: {
      return {
        ...state,
        rewardsDetailsLoading: false,
        rewardsDetailsData: action.payload,
      };
    }
    case rewardsActionTypes.SET_REWARDS_DETAILS_ERROR: {
      return {
        ...state,
        rewardsDetailsLoading: false,
        rewardsDetailsError: action.payload,
      };
    }
    case rewardsActionTypes.GAMIFICATION_DETAIL_LOADING: {
      return {...state, gamificationDetailLoading: true};
    }
    case rewardsActionTypes.GAMIFICATION_DETAIL_SUCCESS: {
      return {
        ...state,
        gamificationDetailLoading: false,
        gamificationDetailData: action.payload,
      };
    }
    case rewardsActionTypes.GAMIFICATION_DETAIL_ERROR: {
      return {
        ...state,
        gamificationDetailLoading: false,
        gamificationDetailError: action.payload,
      };
    }
    case rewardsActionTypes.REWARD_EVENT_LOADING: {
      return {...state, rewardsEventLoading: true};
    }
    case rewardsActionTypes.REWARD_EVENT_SUCCESS: {
      return {
        ...state,
        rewardsEventLoading: false,
        rewardsEventsData: action.payload,
      };
    }
    case rewardsActionTypes.REWARD_EVENT_ERROR: {
      return {
        ...state,
        rewardsEventLoading: false,
        rewardsEventError: action.payload,
      };
    }
    case rewardsActionTypes.REWARDS_DETAILS_LOADING: {
      return {...state, rewardsDetailsMainLoading: true};
    }
    case rewardsActionTypes.REWARDS_DETAILS_SUCCESS: {
      return {
        ...state,
        rewardsDetailsMainLoading: false,
        rewardsDetailsMainData: action.payload,
      };
    }
    case rewardsActionTypes.REWARDS_DETAILS_ERROR: {
      return {
        ...state,
        rewardsDetailsMainLoading: false,
        rewardsDetailsMainError: action.payload,
      };
    }
    case rewardsActionTypes.MM_DETAILS_LOADING: {
      return {...state, mmDetailsLoading: true};
    }
    case rewardsActionTypes.MM_DETAILS_SUCCESS: {
      return {
        ...state,
        mmDetailsLoading: false,
        mmDetailsData: action.payload,
      };
    }
    case rewardsActionTypes.MM_DETAILS_ERROR: {
      return {
        ...state,
        mmDetailsLoading: false,
        mmDetailsError: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export {reducer as rewardsReducer};
